module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="youtube-account-view">\n    ';
 if (connecting) {  ;
__p += '\n        <p class="message">Communicating with YouTube&hellip;</p>\n    ';
 } else if (noChannel) {  ;
__p += '\n        <p class="message">No channel connected to your account.</p>\n    ';
 } else if (authorized) {  ;
__p += '\n        <div class="account-container">\n            <header>\n                <img class="youtube-avatar" src="' +
__e( avatarUrl ) +
'" />\n                <span class="title">' +
__e( title ) +
'</span>\n                <span class="glyphicon glyphicon-list list-icon" data-content="Open account list"></span>\n                <span class="glyphicon glyphicon-refresh refresh-icon" data-content="Reload your videos"></span>\n            </header>\n\n            <div class="account-videos-region"></div>\n        </div>\n    ';
 } else {  ;
__p += '\n        <button class="btn btn-small btn-grey connect">Connect with YouTube account</button>\n    ';
 }  ;
__p += '\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeAccountView.tpl
// module id = 2076
// module chunks = 0